module.exports = __webpack_public_path__ + "static/img/CgoRDGNqIi2AECRDABMv0k40Ie8869.28d9b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGNqIi2AECRDABMv0k40Ie8869.png
// module id = cALc
// module chunks = 73